<template>
  <v-row>
    <a
      :href="jsonData.externalLinks.github"
      :arial-label="jsonData.externalLinks.github"
      target="_blank"
      rel="noreferrer"
    >
      <img src="../assets/icons/github.svg" alt="Github Icon" />
    </a>
    <a
      :href="jsonData.externalLinks.linkedin"
      :arial-label="jsonData.externalLinks.linkedin"
      target="_blank"
      rel="noreferrer"
    >
      <img src="../assets/icons/linkedin.svg" alt="LinkedIn Icon" />
    </a>
    <a
      :href="jsonData.externalLinks.mailto"
      :arial-label="jsonData.externalLinks.mailto"
      target="_blank"
      rel="noreferrer"
    >
      <img src="../assets/icons/email.svg" alt="Email Icon" />
    </a>
    <a
      :href="jsonData.externalLinks.blog"
      :arial-label="jsonData.externalLinks.blog"
      target="_blank"
      rel="noreferrer"
    >
      <img src="../assets/icons/blog.svg" alt="Blog Icon" />
    </a>
    <router-link to="/terminal">
      <img src="../assets/icons/terminal.svg" alt="Terminal Icon" />
    </router-link>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'media-buttons',
  computed: {
    ...mapGetters(['jsonData'])
  }
};
</script>

<style scoped>
.row {
  justify-content: space-evenly;
  max-width: 70vw;
  margin: 0;
  margin-top: 20vh;
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

a {
  -webkit-transition: opacity 0.5s; /* Safari prior 6.1 */
  transition: opacity 0.5s;
}

a:hover {
  opacity: 0.5;
}

img {
  width: 120px;
  height: auto;
}

@media (orientation: portrait) {
  .row {
    max-width: 90vw;
  }
}

@media only screen and (min-device-height: 300px) and (max-device-height: 600px) and (orientation: landscape) {
  img {
    width: 60px;
  }
}

@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  img {
    width: 60px;
  }
}
</style>
